import { TributosAcaoFiscal } from "src/app/acao-fiscal/model/tributo-acao-fiscal";

export const TRIBUTOS_ACAO_FISCAL: TributosAcaoFiscal = {
  "tributos": [
    {
      "codigoTributo": 3333,
      "nomeTributo": "Simples Nacional",
      "anoMesInicio": "08/2014",
      "anoMesFim": "12/2014"
    }
  ]
};
